import { Button as WalrusButton, style } from '@do/walrus';
import styled from 'styled-components';
import newBrandDesignVars from './overwrite-vars.scss';

const NewButton = styled(WalrusButton)`
  margin-top: ${style.vars.whitespace.small};
  border-radius: ${newBrandDesignVars.border_radius_xlarge};
  background: ${newBrandDesignVars.primary};
`;

export default NewButton;
